import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
import { Card, Form, Button } from 'react-bootstrap';

const Strings = require('../../../../app/shared/Strings');
const GlobalFeaturedDemoActions = require('../../actions/GlobalFeaturedDemoActions');
const GlobalFeaturedDemoStore = require('../../stores/GlobalFeaturedDemoStore');
import ErrorBox from '../common/ErrorBox';
import SortableTableClassic from '../table/SortableTableClassic';
import DefinitionListMapped from '../common/definition_list_mapped';
import FeaturedDemoTile from '../DashboardNew/FeaturedDemoTile';

const propTypes = {};
const defaultProps = {};

class AdminFeaturedDemosView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            featuredDemos: GlobalFeaturedDemoStore.getState().featuredDemos,
            getActionId: null,
            error: null,
            selectedFdKey: null,
            addActionId: null,
            updateActionId: null,
            deleteActionId: null,
            addNovaActId: '',
        };

        this.getAllDemos = this.getAllDemos.bind(this);
        this.onFdClick = this.onFdClick.bind(this);
        this.onNovaActIdChange = this.onNovaActIdChange.bind(this);
        this.addFd = this.addFd.bind(this);
        this.onUpdateFd = this.onUpdateFd.bind(this);
        this.deleteFd = this.deleteFd.bind(this);
        this.unsubscribes = [
            GlobalFeaturedDemoStore.listen(this.onGlobalFeaturedDemoStoreChange.bind(this))
        ];
    }

    componentDidMount() {
        this.getAllDemos();
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    getAllDemos() {
        if (!this.state.getActionId) {
            const getActionId = uuid.v4();
            this.setState({ getActionId: getActionId }, () => {
                GlobalFeaturedDemoActions.getAll(getActionId, { all: true });
            });
        }
        else {
            console.warn(Strings['en'].featured_demo.admin.WARN_ALREADY_GETTING);
        }
    }

    onFdClick(e, id) {
        this.setState({ selectedFdKey: id });
    }

    onNovaActIdChange(e) {
        this.setState({ addNovaActId: e.target.value });
    }

    addFd() {
        if (!this.state.addNovaActId) {
            return;
        }

        const addActionId = uuid.v4();
        this.setState({ addActionId: addActionId }, () => {
            GlobalFeaturedDemoActions.add(addActionId, { novaActId: this.state.addNovaActId });
        });
    }

    onUpdateFd(id, updateArgs) {
        const updateActionId = uuid.v4();
        this.setState({ updateActionId: updateActionId }, () => {
            GlobalFeaturedDemoActions.update(updateActionId, { id: id, ...updateArgs });
        });
    }

    deleteFd(id) {
        if (window.confirm(Strings['en'].featured_demo.admin.CONFIRM_DELETE)) {
            const deleteActionId = uuid.v4();
            this.setState({ deleteActionId: deleteActionId }, () => {
                GlobalFeaturedDemoActions.delete(deleteActionId, { id: id });
            });
        }
    }

    onGlobalFeaturedDemoStoreChange(state) {
        let updatedState = {};
        if (state.action.id === this.state.getActionId) {
            updatedState = { getActionId: null };
            if (!state.action.error) {
                updatedState.error = null;
                updatedState.featuredDemos = state.featuredDemos;
            }
            else {
                updatedState.error = state.action.error;
            }

        }
        else if (state.action.id === this.state.addActionId) {
            updatedState = { addActionId: null };
            if (!state.action.error) {
                updatedState.error = null;
                updatedState.featuredDemos = state.featuredDemos;
            }
            else {
                updatedState.error = state.action.error;
            }

        }
        else if (state.action.id === this.state.updateActionId) {
            updatedState = { updateActionId: null };
            if (!state.action.error) {
                updatedState.error = null;
                updatedState.featuredDemos = state.featuredDemos;
            }
            else {
                updatedState.error = state.action.error;
            }

        }
        else if (state.action.id === this.state.deleteActionId) {
            updatedState = { deleteActionId: null };
            if (!state.action.error) {
                updatedState.error = null;
                updatedState.selectedFdKey = null;
                updatedState.featuredDemos = state.featuredDemos;
            }
            else {
                updatedState.error = state.action.error;
            }
            
        }

        if (Object.keys(updatedState).length > 0) {
            this.setState(updatedState);
        }

    }

    render() {
        const selectedFd = this.state.selectedFdKey ? this.state.featuredDemos.find(fd => fd.fd_id == this.state.selectedFdKey) : null;
        return (
            <div>
                <Card>
                    <Card.Body>
                        <h2>{Strings['en'].featured_demo.FEATURED_DEMOS}</h2>
                        <p>{Strings['en'].featured_demo.admin.MANAGE_DESC}</p>
                    </Card.Body>
                </Card>

                <ErrorBox error={this.state.error} />

                <div className="margin-bottom-lg">
                    <Card body bg="light">
                        <h2 className="view-title">
                            {Strings['en'].featured_demo.admin.ADD_TITLE}
                        </h2>
                        <p>{Strings['en'].featured_demo.admin.ADD_DESC}</p>
                        <Form>
                            <Form.Group controlId="token-desc">
                                <Form.Label>{Strings['en'].featured_demo.admin.ADD_FORM_NOVA_ACT_ID}</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={this.state.addNovaActId}
                                    onChange={this.onNovaActIdChange}
                                />
                            </Form.Group>
                            <Button onClick={this.addFd} disabled={!!this.state.addActionId || !this.state.addNovaActId}>
                                {Strings['en'].common.ADD}
                            </Button>
                        </Form>
                    </Card>
                </div>

                <Card body bg="light">
                    <SortableTableClassic
                        title={Strings['en'].featured_demo.FEATURED_DEMOS}
                        onRowClick={this.onFdClick}
                        rows={this.state.featuredDemos}
                        uniqueRowKey="fd_id"
                        selectedRowKey={this.state.selectedFdKey}
                        dateFormat="YYYY-MM-DD"
                        columns={[
                            {
                                displayName: Strings['en'].common.ID,
                                key: 'fd_id',
                                size: 1,
                                type: 'int'
                            },
                            {
                                displayName: Strings['en'].activity.ACTIVITY,
                                key: 'title',
                                size: 3,
                                type: 'string'
                            },
                            /*{
                                displayName: 'Expires At',
                                key: 'fd_expires_at',
                                size: 2,
                                type: 'date'
                            },*/
                            {
                                displayName: Strings['en'].common.ENABLED,
                                key: 'fd_enabled',
                                size: 1,
                                type: 'bool'
                            }
                        ]}
                    />
                </Card>

                {(!!selectedFd) &&
                    <Card body bg="light">
                        <h2 className="view-title">
                            {Strings['en'].featured_demo.admin.SELECTED_FD}
                        </h2>

                        <div className="margin-bottom-md">
                            <h3 className="md-heading margin-bottom-sm">{Strings['en'].common.STATUS}</h3>
                            {Strings['en'].common.ENABLED}: {!!selectedFd.fd_enabled ? Strings['en'].common.YES : Strings['en'].common.NO}
                        </div>

                        <div className="margin-bottom-md">
                            <h3 className="md-heading margin-bottom-sm">{Strings['en'].common.PREVIEW}</h3>
                            <FeaturedDemoTile demo={selectedFd} />
                        </div>

                        <div className="margin-bottom-md">
                            <h3 className="md-heading margin-bottom-sm">{Strings['en'].common.ACTIONS}</h3>
                            {(selectedFd.fd_enabled) ?
                                <Button disabled={!!this.state.updateActionId} onClick={() => this.onUpdateFd(this.state.selectedFdKey, { enabled: false })}>{Strings['en'].common.DISABLE}</Button>
                                :
                                <Button disabled={!!this.state.updateActionId} onClick={() => this.onUpdateFd(this.state.selectedFdKey, { enabled: true })}>{Strings['en'].common.ENABLE}</Button>
                            }
                            <Button className="margin-left-md" variant="danger" onClick={() => this.deleteFd(this.state.selectedFdKey)}>{Strings['en'].common.DELETE}</Button>
                        </div>

                        <h3 className="md-heading margin-bottom-sm">{Strings['en'].common.DETAILS}</h3>
                        <DefinitionListMapped
                            className="inline-list-elems list-spaced"
                            definitions={selectedFd}
                        />
                    </Card>
                }

                
            </div>
        );
    }
}

AdminFeaturedDemosView.propTypes = propTypes;
AdminFeaturedDemosView.defaultProps = defaultProps;

export default AdminFeaturedDemosView;